import React from 'react'
import Yup from '../../../../../helpers/custom-yup'
import Title from '../../../../../components/typography/title.component'
import Button from '../../../../../components/buttons/buttons.component'
import ModalConfirmation from './../../../../../components/modal/modal-confirmation.component'
import InnerPageContainer from '../../../../../components/layout/private/inner-page-container.component'
import PaginationComponent from '../../../../../components/pagination/pagination.component'
import { withRouter } from 'react-router-dom'
import { toastActions } from '../../../../../actions'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import { StyledForm, StyledSectionHeader } from './styles.style'
import { bindActionCreators } from 'redux'
import { AdminReportsService } from '../../../../../services/admin-reports.service'
import { MuvicardAdminService } from '../../../../../services/muvicard-admin.service'
import { invoicesActions } from './invoices.actions'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'
import StyledInputContainer from '../../../../../components/form-components/styled-input-container.component'
import DatepickerInput from '../../../../../components/form-components/datepicker-input.component'
import {
	NumberInput,
	SelectInput,
	TextInput,
	CPFInput
} from '../../../../../components/form-components/inputs.component'
import { invoiceStatus } from './invoices.constants'
import { maskHelper } from './../../../../../helpers/mask.helper'

class InvoicesReportPage extends React.Component {
	constructor(props) {
		super(props)
		this.isExporting = false
		this.initialValues = {
			name: '',
			muviflexNumber: '',
			cpf: '',
			startingDueDate: null,
			endingDueDate: null,
			invoiceStatus: ''
		}
		this.schema = Yup.object().shape({
			name: Yup.string(),
			muviflexNumber: Yup.number().positive(),
			cpf: Yup.string(),
			invoiceStatus: Yup.string()
		})
		this.state = {
			params: {},
			modalIsOpen: false,
			modalButtonEnabled: false,
			modalText: '',
			modalInvoiceId: ''
		}
	}

	componentDidMount() {
		onSubmit.call(this, this.initialValues)
	}

	render() {
		const { modalIsOpen, modalButtonEnabled, modalText } = this.state
		return (
			<InnerPageContainer>
				<Title>Relatório de faturas</Title>
				<StyledSectionHeader>Filtros</StyledSectionHeader>
				<Formik
					initialValues={this.initialValues}
					onSubmit={onSubmit.bind(this)}
					validationSchema={this.schema}
					ref={'form'}
					render={props => (
						<StyledForm noValidate onSubmit={props.handleSubmit}>
							<div className="col1">
								<StyledInputContainer
									style={{ gridColumn: '1 / span 2' }}>
									<TextInput id="name" label="Nome" {...props} />
								</StyledInputContainer>
								<StyledInputContainer>
									<NumberInput
										id="moveflexNumber"
										label="Número Muviflex"
										{...props}
									/>
								</StyledInputContainer>
								<StyledInputContainer>
									<CPFInput id="cpf" label="CPF" {...props} />
								</StyledInputContainer>
							</div>
							<div className="col1">
								<StyledInputContainer>
									<DatepickerInput
										showClearDate
										id="startingDueDate"
										label="Data vencimento fatura - Início"
										{...props}
									/>
								</StyledInputContainer>
								<StyledInputContainer>
									<DatepickerInput
										showClearDate
										id="endingDueDate"
										label="Data vencimento fatura - Final"
										{...props}
									/>
								</StyledInputContainer>
								<StyledInputContainer>
									<SelectInput
										id="invoiceStatus"
										name="invoiceStatus"
										label="Situação da fatura"
										placeholder="Todas"
										defaultValue={{
											value: '',
											label: 'Todas'
										}}
										options={[
											{ label: 'Todas', value: '' },
											{ label: 'Fechadas', value: 'Fechada' },
											{ label: 'Atrasadas', value: 'Vencida' },
											{ label: 'Pagas', value: 'Paga' },
											{ label: 'Abertas', value: 'Aberta' }
										]}
										multi={false}
										{...props}
									/>
								</StyledInputContainer>
							</div>
							<div
								style={{ display: 'flex', justifyContent: 'flex-end' }}>
								<Button data-permission="983913EB3045D081F56ABE521E0A5DDC65867E8A"
									secondary
									style={{ marginRight: '15px' }}
									type="button"
									onClick={exportData.bind(this)}>
									Exportar
								</Button>
								<Button primary type="submit" data-permission="08872D45C89DA062498913A416DD201F8517F25E">
									Consultar
								</Button>
							</div>
						</StyledForm>
					)}
				/>
				<div style={{ marginTop: '20px', width: '100%' }} data-permission="08872D45C89DA062498913A416DD201F8517F25E">
					<PaginationComponent
						ref="pagination"
						rowsPerPage={100}
						params={this.state.params}
						getData={AdminReportsService.searchInvoices}
						headers={[
							{ header: 'Vencimento', key: 'dueDate' },
							{ header: 'Competência', key: 'competence' },
							{ header: 'Situação', key: 'invoiceStatus' },
							{ header: 'Nome', key: 'name' },
							{ header: 'CPF', key: 'cpf' },
							{ header: 'Valor Fatura', key: 'invoiceValue' },
							{ header: 'Data Pagamento', key: 'paymentDate' },
							{ header: 'Valor Pago', key: 'payedValue' },
							{ header: 'Juros Pago', key: 'interestValue' }
						]}
						sortable={{
							defaultOrder: 'desc',
							cols: [
								{ key: 'dueDate' },
								{ key: 'name' },
								{ key: 'invoiceValue' },
								{ key: 'invoiceStatus' }
							]
						}}
						renderRow={(rowData, headers) => {
							return headers.map(({ key, align }) => (
								<td
									key={key}
									align={align}
									onClick={() => {
										this.handleRowClicked(
											rowData.invoiceStatus,
											rowData.name,
											rowData.dueDate,
											rowData.id
										)
									}}
									style={key == 'invoiceStatus' ? shouldBeColored(rowData) : {}}>
									<span title={rowData[key]}>
										{getRowInfo(rowData, rowData[key], key)}
									</span>
								</td>
							))
						}}
					/>
				</div>
				* Valor calculado de forma parcial.
				<div data-permission="15A0523E8B11E69C5ADAB0AAAD0B87053A5006F7">
					<ModalConfirmation
						OnlyNoButton={!modalButtonEnabled}
						isOpen={modalIsOpen}
						buttonNoText={'Voltar'}
						buttonYesText={
							modalButtonEnabled ? 'Baixar fatura' : 'Continuar'
						}
						onResult={this.onResult}
						title={`Fatura`}>
						{modalText}
					</ModalConfirmation>
				</div>
			</InnerPageContainer>
		)
	}


	onResult = confirmed => {
		const { modalButtonEnabled, modalInvoiceId, params } = this.state
		if (confirmed && modalButtonEnabled && !!modalInvoiceId) {
			MuvicardAdminService.closeBankslip(modalInvoiceId)
				.then(
					this.setState({ params }, () => this.refs.pagination.reload())
				)
		}
		this.setState({
			modalIsOpen: false,
			modalButtonEnabled: false,
			modalText: '',
			modalInvoiceId: ''
		})
	}

	handleRowClicked = (status, name, dueDate, id) => {
		const buttonEnabled =
			status === invoiceStatus.DELAYED || status === invoiceStatus.CLOSED
		this.setState({
			modalIsOpen: true,
			modalButtonEnabled: !!buttonEnabled,
			modalText: `Fatura ${status.toLowerCase()} de ${name} com data de vencimento para ${dueDate}`,
			modalInvoiceId: id
		})
	}
}

const shouldBeColored = rowData => {
	switch (rowData.invoiceStatus) {
		case 'Vencida':
			return { color: 'red', fontWeight: "bold" }
		case 'Fechada':
			break;
		case 'Aberta':
			break;
		case 'Paga':
			return { color: 'green', fontWeight: "bold" }
		default:
			return {}
	}
}

const getRowInfo = (rowData, value, key) => {
	var response = value;

	if (key === 'cpf')
		response = maskHelper.applyCpf(value);
	if (key === 'invoiceValue' || key === 'payedValue' || key == 'interestValue' || key == 'feeValue')
		response = `R$ ${maskHelper.applyBrazilianCurrency(value)}`;

	if (rowData.invoiceStatus == "Aberta" && key === 'invoiceValue') {
		response = "*" + response;
	}
	return response;
}

function onSubmit(values) {
	const { exportData } = this.props

	const params = Object.assign({}, values)
	if (this.isExporting) {
		this.isExporting = false
		exportData(params)
	} else {
		this.setState({ params }, () => this.refs.pagination.reload())
	}
}

function exportData() {
	this.isExporting = true
	this.refs.form.submitForm()
}

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			...invoicesActions,
			...SiteCreators,
			...toastActions
		},
		dispatch
	)

const connectedInvoicesReportPage = withRouter(
	connect(null, mapDispatchToProps)(InvoicesReportPage)
)

export { connectedInvoicesReportPage as ModuleRootComponent }
